import dynamic from 'next/dynamic'
import React, { FC } from 'react'

import { makeStyles, Theme } from '@material-ui/core/styles'

import Section from '~/components/shared/Section'
import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'
import { BlogFeaturedSliderType } from '~/views/Blog/BlogFeaturedSlider/types'

const BlogFeaturedItems = dynamic(() =>
  import('~/views/Blog/BlogFeaturedSlider/BlogFeaturedItems.desktop')
)
const BlogFeaturedItemsMobile = dynamic(() =>
  import('~/views/Blog/BlogFeaturedSlider/BlogFeaturedItems.mobile')
)

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minHeight: '552px'
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '250px'
      // '& .blog-feature-desktop': {
      //   display: 'none'
      // },
      // '& .blog-feature-mobile': {
      //   display: 'block !important'
      // }
    }
    // '& .blog-feature-mobile': {
    //   display: 'none'
    // }
  }
}))

const BlogFeaturedSlider: FC<BlogFeaturedSliderType> = ({ data, loading }) => {
  const classes = useStyles()

  if (!loading && !data?.length) return null

  return (
    <Section bgcolor="bg.secondary" className={classes.root}>
      <Mobile>
        <BlogFeaturedItemsMobile
          className="blog-feature-mobile"
          data={data}
          loading={loading}
        />
      </Mobile>
      <Desktop>
        <BlogFeaturedItems
          className="blog-feature-desktop"
          data={data}
          loading={loading}
        />
      </Desktop>
    </Section>
  )
}

export default BlogFeaturedSlider
